
  document.addEventListener('DOMContentLoaded', function () {
    const parentItems = document.querySelectorAll('.menu-parent-item');

    parentItems.forEach((parentItem) => {
      const childItems = parentItem.querySelectorAll('.menu-child-item');
      const childMenu = parentItem.querySelector('.list-menu-child');

      if (!childItems.length || !childMenu) return;

      // Show child menu on parent hover
      parentItem.addEventListener('mouseenter', () => {
        // Remove 'active' from all parents
        document.querySelectorAll('.menu-parent-item.active').forEach(p => p.classList.remove('active'));
        parentItem.classList.add('active');

        // Reset all active child items in other menus
        document.querySelectorAll('.menu-child-item.active').forEach(c => c.classList.remove('active'));

        // Activate first child item and show its grandchild menu
        childItems[0].classList.add('active');
      });

      parentItem.addEventListener('mouseleave', () => {
        parentItem.classList.remove('active');
        childItems.forEach(item => item.classList.remove('active'));
      });

      // Handle grandchild menus
      childItems.forEach((childItem) => {
        childItem.addEventListener('mouseenter', () => {
          // Remove active from siblings
          childItems.forEach(ci => ci.classList.remove('active'));
          childItem.classList.add('active');
        });
      });
    });
  });

/* Snow conffeti changes starts */
//   document.addEventListener('DOMContentLoaded', function(){
//     var script = document.createElement('script');
//     script.src = 'https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js';
//     script.onload = function(){
//         particlesJS("snow", {
//             "particles": {
//                 "number": {
//                     "value": 100,
//                     "density": {
//                         "enable": true,
//                         "value_area": 800
//                     }
//                 },
//                 "color": {
//                     "value": "#ffffff"
//                 },
//                 "opacity": {
//                     "value": 0.7,
//                     "random": false,
//                     "anim": {
//                         "enable": false
//                     }
//                 },
//                 "size": {
//                     "value": 5,
//                     "random": true,
//                     "anim": {
//                         "enable": false
//                     }
//                 },
//                 "line_linked": {
//                     "enable": false
//                 },
//                 "move": {
//                     "enable": true,
//                     "speed": 3,
//                     "direction": "bottom",
//                     "random": true,
//                     "straight": false,
//                     "out_mode": "out",
//                     "bounce": false,
//                     "attract": {
//                         "enable": true,
//                         "rotateX": 300,
//                         "rotateY": 1200
//                     }
//                 }
//             },
//             "interactivity": {
//                 "events": {
//                     "onhover": {
//                         "enable": false
//                     },
//                     "onclick": {
//                         "enable": false
//                     },
//                     "resize": false
//                 }
//             },
//             "retina_detect": true
//         });
//     }
//     document.head.append(script);
// });
/* Snow conffeti changes ends */

